<template>
  <div class="relative">
    <div class="grid" :class="{ 'sticky top-0': heroEffect === 'parallax' }">
      <div class="relative grid-area-stack" style="max-height: 90vh">
        <cms-shared-media v-if="media" :media />
      </div>
      <div class="z-1 w-full flex items-end pb-10 grid-area-stack" :class="insetClasses">
        <div class="space-y-2" :class="titleColor">
          <p v-if="!hidePageDate" class="text-md fw-bold">
            {{ date }}
          </p>
          <h1 class="display-3">
            {{ title }}
          </h1>
          <p class="subtitle-2">
            {{ subtitle }}
          </p>
        </div>
      </div>
    </div>
    <div v-style:bg="backgroundColor" class="relative z-1 flow-root">
      <div class="my-6">
        <slot />
      </div>

      <div v-if="relatedArticles.length" class="mb-10" :class="insetClasses">
        <h2 class="mb-4 body-2">
          {{ $t.relatedBlogs }}
        </h2>
        <vf-carousel-elevate class-container="gap-x-1" :show-arrows="false">
          <vf-article-card-v2
            v-for="article in relatedArticles"
            :key="article.id"
            style="max-width: 23.75rem"
            v-bind="article"
          />
        </vf-carousel-elevate>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { PageContent } from '#types/page'

const { page } = defineProps<{ page: PageContent }>()

const { getSearch } = useCms()

const {
  backgroundColor,
  date,
  headerStyle = 'light',
  heroEffect,
  hidePageDate,
  media,
  pageMaxWidth,
  relatedQuery,
  subtitle,
  title,
} = page

useSchemaOrg([
  defineArticle({
    headline: title,
    description: subtitle,
    datePublished: date
  })
])

const { section } = useAppConfig().components.cms

const insetClasses = getContentInset({
  componentMaxWidth: pageMaxWidth,
  componentSidePaddings: { sm: true, lg: true }
}, section)

const titleColor = headerStyle === 'dark' ? 'c-white' : 'c-brand-4'

const RELATED_ARTICLES_COUNT = '4'

let relatedArticles: any[] = []

if (relatedQuery) {
  const query = new URLSearchParams(relatedQuery)
  query.set('limit', RELATED_ARTICLES_COUNT)

  const data = await getSearch('article', { ...Object.fromEntries(query), limit: 4 })

  relatedArticles = (data?.result || []).map((article) => ({
    ...article,
    to: article.url,
    image: {
      src: article.picture?.url,
      alt: article.picture?.alt || article.title
    },
    tags: [article.tags[0]?.label]
  }))
}
</script>
